import { useLayoutMode } from "./LayoutModeContext";
import "./layoutMode.css";

const OPTIONS = [
  { value: "classic", label: "Κλασική", title: "Η κλασική προβολή" },
  { value: "desktop", label: "Desktop", title: "Η προβολή desktop (σε οθόνες από 1024px)" },
];

// Segmented control for choosing between the classic and the desktop layout.
const LayoutModeToggle = ({ className = "" }) => {
  const { pref, setPref, isDesktopWidth } = useLayoutMode();
  if (!isDesktopWidth) return null;

  return (
    <div
      role="radiogroup"
      aria-label="Προβολή"
      className={`layout-mode-toggle ${className}`}
    >
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          role="radio"
          aria-checked={pref === opt.value}
          title={opt.title}
          className={pref === opt.value ? "is-active" : ""}
          onClick={() => setPref(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
};

export default LayoutModeToggle;
